import Lightbox from '@uikit/components/Lightbox/Lightbox';
import Picture from '@uikit/components/Picture/Picture';
import { Asset } from '@uikit/types';
import { useState } from 'react';
import styles from './FullScreenGallery.module.scss';
import type { FullScreenGalleryProps } from './types';

const FullScreenGallery = ({
  images,
  handleOpen,
  isOpen,
}: FullScreenGalleryProps) => {
  const [spotlightImage, setSpotlightImage] = useState<Asset>(images[0]);

  return (
    <Lightbox active={isOpen} onClose={handleOpen}>
      <div className={styles.base}>
        <div className={styles.spotlight}>
          <Picture
            asset={spotlightImage}
            className={styles.image}
            objectFit="contain"
          />
        </div>

        <div className={styles.previewImages}>
          {images.map((image) => (
            <div
              key={image.path}
              onClick={() => setSpotlightImage(image)}
              className={styles.image}
              data-spotlighted={spotlightImage.path === image.path}
            >
              <Picture asset={image} fill objectFit="cover" />
            </div>
          ))}
        </div>
      </div>
    </Lightbox>
  );
};

export default FullScreenGallery;
